import { atomWithStorage } from 'jotai/utils';

export const timeZoneAtom = atomWithStorage('TZ', Intl.DateTimeFormat().resolvedOptions().timeZone);

export const autoLoginAtom = atomWithStorage('AUTO_LOGIN', null);

export const tempUnitAtom = atomWithStorage<'CELSIUS' | 'FAHRENHEIT'>('TEMP_UNIT', 'CELSIUS');
